import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { queryParamsBrand } from '../financial-setup/model.models';


@Injectable({
providedIn: 'root',
})
export class BrandService {

    constructor(public api: ApiService, public httpClient: HttpClient) {}

    updateBrand(id: number, data: any): Observable<any> {
        return this.api.put(`${environment.API_QUOTE_SERVICE}/brands/${id}`, data);
    }

    getAllBrands(data: queryParamsBrand): Observable<any> {
        //filtros
        return this.api.post(`${environment.API_QUOTE_SERVICE}/brands/all`,data);
    }

    getBrand(id: number, data: any): Observable<any> {
        return this.api.post(`${environment.API_QUOTE_SERVICE}/brands/${id}`, data);
    }

    createBrand(data: any): Observable<any> {
        return this.api.post(
            `${environment.API_QUOTE_SERVICE}/brands`, data);
      }

    deleteBrand(id: number): Observable<any> {
        return this.api.delete(`${environment.API_QUOTE_SERVICE}/brands/${id}`,'');
    }
}